
	<div
		*ngIf="interactivityEditorService.parentEntityType !== 'App'"
		#leftDragger
		class="dragger dragleft"
		>
		<div class="dragger-visual"></div>
	</div>

	<div *ngIf="widget?.type === 'image'"
			class="img-wrapper"
			[ngClass]="{'app-editor': interactivityEditorService.parentEntityType === 'App' || interactivityEditorService.parentEntityType === 'Project'}">
		<img
		alt=""
		[hidden]="!widget?.config?.imageid" 
		[src]="baseUrl
		+ '/mediaclip/'
		+ widget?.config?.imageid
		+ '/pthumbnail/300/200.jpg'" class="option-img" />
		<i class="fa fa-image" *ngIf="!widget?.config?.imageid"></i>
	</div>

	<div #textElement class="text" 
		[style.width]="trackComponent?.viewPortWidth"
		[ngClass]="{'app-editor': interactivityEditorService.parentEntityType === 'App' || interactivityEditorService.parentEntityType === 'Project'}">
		{{widget?.label}}
	</div>

	<div *ngIf="interactivityEditorService.parentEntityType !== 'App' && interactivityEditorService.parentEntityType !== 'Project'" #rightDragger class="dragger dragright">
		<div class="dragger-visual"></div>
	</div>
	<ng-content></ng-content>
